import { CurveManagementContent } from './curve-management-content';

export function CurveManagementPage() {
  return <CurveManagementContent />;
}
